import { render } from "./WalletCircleYellowIcon.vue?vue&type=template&id=503b2f26"
import script from "./WalletCircleYellowIcon.vue?vue&type=script&lang=js"
export * from "./WalletCircleYellowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__